module.exports = __webpack_public_path__ + "static/CCQ_CorredorSudeste-1052b4d352fa893d77baf07addf74153.jpg";